import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import styles from "./GeneralBanner.module.scss";
import { GeneralBannerQueryResult } from "../../../../studio/sanity.types";
import { CustomLink } from "../../components/CustomLink/CustomLink";
import { BannerContext } from "../../../main/layout/layout";
import { usePlausible } from "next-plausible";
export const GeneralBanner: React.FC<{
  configuration: GeneralBannerQueryResult;
}> = t0 => {
  const $ = _c(22);
  const {
    configuration
  } = t0;
  const plausible = usePlausible();
  const [bannerContext, setBannerContext] = useContext(BannerContext);
  if (!configuration) {
    return null;
  }
  if (!configuration.link) {
    return null;
  }
  if (bannerContext.generalBannerDismissed) {
    return null;
  }
  const t1 = configuration.link.slug as string;
  let t2;
  if ($[0] !== configuration.link.slug || $[1] !== plausible || $[2] !== setBannerContext) {
    t2 = () => {
      plausible("GeneralBannerClick", {
        props: {
          link: configuration.link?.slug
        }
      });
      setBannerContext(_temp);
    };
    $[0] = configuration.link.slug;
    $[1] = plausible;
    $[2] = setBannerContext;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== configuration.title) {
    t3 = <p>{configuration.title}</p>;
    $[4] = configuration.title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== configuration.link.title) {
    t4 = <span>{configuration.link.title} →</span>;
    $[6] = configuration.link.title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className={styles.description}>{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== configuration.link.slug || $[12] !== plausible || $[13] !== setBannerContext) {
    t6 = <div className={styles.buttonsWrapper}><span className={styles.dismiss} onClick={e => {
        e.stopPropagation();
        e.preventDefault();
        plausible("GeneralBannerDismissed", {
          props: {
            link: configuration.link?.slug
          }
        });
        setBannerContext(_temp2);
      }}>✕</span></div>;
    $[11] = configuration.link.slug;
    $[12] = plausible;
    $[13] = setBannerContext;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div data-cy="generalbanner-container" className={styles.container}><div className={styles.content}>{t5}{t6}</div></div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t7) {
    t8 = <><CustomLink href={t1} onClick={t2}>{t7}</CustomLink></>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
function _temp(prev) {
  return {
    ...prev,
    generalBannerDismissed: true
  };
}
function _temp2(prev_0) {
  return {
    ...prev_0,
    generalBannerDismissed: true
  };
}